import { Endpoint } from '../endpoint';

export const ReferenceListDependencyView = new Endpoint('reference_list_dependency_view');
